window.mcb.forms.data = (function () {
  const _logger = window.mcb.utilities.createLogger("forms.data");
  let _formLogics = {};
  let _formSettings = {};

  const formatReturnMessage = function (targetId, token, lowerCaseToken, message, fallbackValue, success) {
    const logObj = {
      targetId,
      token,
      lowerCaseToken,
      message,
      fallbackValue,
      success
    };

    _logger.trace('getMessageFromToken returning', logObj);

    return message;
  }

  return _ = {
    get_FormLogics: function (targetId) {
      if (typeof _formLogics[targetId] !== 'undefined') {
        return _formLogics[targetId];
      }

      return null;
    },
    set_FormLogics: function (targetId, formLogic) {
      _formLogics[targetId] = formLogic;
    },
    get_FormSettings: function (targetId) {
      if (typeof _formSettings[targetId] !== 'undefined') {
        return _formSettings[targetId];
      }

      return null;
    },
    set_FormSettings: function (targetId, formSettings) {
      const transposed = {};
      for (let token in formSettings.messages) {
        transposed[token.toLowerCase()] = formSettings.messages[token];
      }

      formSettings.messages = transposed;

      _formSettings[targetId] = formSettings;
    },
    compileTokenValue: function (targetId, token, data = null, fallbackValue = "") {
      let _tokenParts = token.split('|');
      let _token = _tokenParts[0];
      let _tokenParser = _tokenParts.length > 1 ? _tokenParts[1] : null;

      let relevantData = data === null ? null : data[_token] ?? null;
      if (relevantData === null) {
        return this.getMessageFromToken(targetId, _token, fallbackValue);
      }

      let result;
      if (Array.isArray(relevantData) && relevantData.length > 0) {
        let string = "";
        for (let i = 0; i < relevantData.length; i++) {
          string += relevantData[i];

          if (i + 2 === relevantData.length) {
            string +=
              " " +
              this.getMessageFromToken(
                targetId,
                "or"
              ) +
              " ";
          }
          else if (i + 2 < relevantData.length) {
            string += ", ";
          }
        }

        result = string;
      }
      else {
        result = relevantData.toString();
      }

      if (_tokenParser !== null) {
        switch (_tokenParser) {
          case 'filesize':
            if (isNaN(result)) {
              _logger.warn('Failed to parse value "' + result + '", as File Size requires a number as input');
            }
            else {
              result = window.mcb.forms.helpers.renderFileSize(parseInt(result));
            }
            break;
          default:
            _logger.warn('Failed to parse value "' + result + '", as there is no parser matching "' + _tokenParser + '"');
            break;
        }
      }

      return this.tokenizeText(targetId, result, data);
    },
    tokenizeText: function (targetId, text = null, data = null) {
      if (text === null || text.trim() === "" || text.indexOf('{') < 0) {
        return text;
      }

      let splt = text.split('{');
      let result = "";
      for (let iteration of splt) {
        let is = iteration.indexOf('}');
        let addIteration = iteration;
        if (is >= 0) {
          let token = iteration.substring(0, is);
          if (token.indexOf(' ') < 0 && token !== "") {
            addIteration = this.compileTokenValue(targetId, token, data) + iteration.substring(is + 1);
          }
        }

        result += addIteration;
      }

      return this.tokenizeText(targetId, result, data);
    },
    getMaxFileSize: function (targetId, limited = true) {
      if (typeof _formSettings[targetId] !== 'undefined' && typeof _formSettings[targetId].maxSizes !== 'undefined') {
        if (limited ?? true) {
          return (_formSettings[targetId].maxSizes.fileLimited);
        }

        return (_formSettings[targetId].maxSizes.fileUnLimited);
      }

      return null;
    },
    getMessageFromToken: function (targetId = null, origninalToken = null, fallbackValue = undefined) {
      if (typeof fallbackValue === 'undefined') { // Allow fallbackvalue to be null
        fallbackValue = origninalToken;
      }

      if (targetId === null) {
        _logger.error('Failed to load Message as the Form Id is missing');
        return fallbackValue;
      }

      if (targetId === null || origninalToken === null) {
        _logger.warn('Failed to load Message for Missing Token');
        return fallbackValue;
      }

      let token = origninalToken.toLowerCase();
      if (typeof di !== 'undefined' && typeof di.language !== 'undefined') {
        if (
          typeof _formSettings[targetId] !== 'undefined' &&
          typeof _formSettings[targetId].messages[di.language] !== 'undefined' &&
          typeof _formSettings[targetId].messages[di.language][token] !== 'undefined'
        ) {
          return formatReturnMessage(targetId, origninalToken, token, _formSettings[targetId].messages[di.language][token], fallbackValue, true);
        }
      }

      if (
        typeof _formSettings[targetId] !== 'undefined' &&
        typeof _formSettings[targetId].messages[token] !== 'undefined'
      ) {
        return formatReturnMessage(targetId, origninalToken, token, _formSettings[targetId].messages[token], fallbackValue, true);
      }

      _logger.warn('Failed to load Message for Token: "' + token + '"');
      return formatReturnMessage(targetId, origninalToken, token, fallbackValue, fallbackValue, false);
    },
    getErrorMessageFromCode: function (targetId = null, errorCode = null, fallbackValue = null) {
      if (errorCode === null) {
        return fallbackValue;
      }

      if (typeof errorCode === 'number') {
        errorCode = errorCode.toString();
      }

      if (fallbackValue === null) {
        fallbackValue = errorCode;
      }

      if (errorCode.trim() === "") {
        return fallbackValue;
      }

      let data = this.getMessageFromToken(targetId, 'ErrorCode' + errorCode, null);
      if (data === null) {
        if (errorCode.length === 1) {
          return this.getMessageFromToken(targetId, 'ErrorCodeUnknown', 'Unkown Error');
        }

        const newCode = errorCode.substring(0, errorCode.length - 1);
        if (newCode.length > 0) {
          return this.getErrorMessageFromCode(targetId, newCode, fallbackValue);
        }

        data = fallbackValue;
      }

      return data;

    },
    getMessageFromTokenArray: function (targetId, tokenArray) {
      for (let token of tokenArray) {
        let res = this.getMessageFromToken(targetId, token);
        if (res !== token) {
          return res;
        }
      }

      return tokenArray.join(', ');
    },
    getNextId: function (baseId, suggestedIndex) {
      let newId = baseId + "_" + suggestedIndex;
      if (jQuery("#" + newId).length === 0) {
        return newId;
      }

      return this.getNextId(baseId, suggestedIndex + 1);
    }
  };
})();
